module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.fc0337b.woff2";